import axios from 'axios'

class ReportService {
	getStartDataForCreateReport() {
		return axios.get('report/start_data_create_report/')
	}

	getPreviousContract() {
		return axios.get('report/get_previous_request_contracts/')
	}

	createReport(formData) {
		return axios.post('report/create_report/', { formData: formData })
	}

	createNewContract(formData) {
		return axios.post('report/create_new_contract/', { formData: formData })
	}

	deleteContract(contractId) {
		return axios.delete(`report/delete_contract/${contractId}`)
	}

	stopContract(contractId) {
		return axios.post(`report/stop_contract/${contractId}`)
	}

	createMetalPlace(formData, reportId) {
		return axios.post(`report/create_metal_place/${reportId}/`, {
			formData: formData,
		})
	}

	updateMetalPlace(formData, reportId) {
		return axios.post(`report/update_metal_place/${reportId}/`, {
			formData: formData,
		})
	}

	createTest(formData) {
		return axios.post('report/create_test/', { formData: formData })
	}

	getHistory(id) {
		return axios.get('report/history_report/' + id + '/')
	}

	getReport(id) {
		return axios.get('report/view_report/' + id + '/')
	}

	getCommonReportData(id) {
		return axios.get('report/view_report_common_data/' + id + '/')
	}

	getMetalPlace(reportId) {
		return axios.get(`report/view_report/${reportId}/place-view/`)
	}

	canBeSignedReport(reportId) {
		return axios.get(`report/can_be_signed_report/${reportId}/`)
	}

	getPlaceStartData(reportId) {
		return axios.get(`report/view_report/${reportId}/place/`)
	}

	getInitialData(reportId) {
		return axios.get(`report/view_report/${reportId}/init_place_data/`)
	}

	isForceEdit(reportId) {
		return axios.get(`report/view_report/${reportId}/is_force/`)
	}

	getInitCategories(id) {
		return axios.get('report/view_report_init/' + id + '/')
	}

	getListSignXml(id) {
		return axios.get('report/report_force_list_sing_xml/' + id + '/')
	}

	updateReport(formData) {
		return axios.post('report/update_report/', { formData: formData })
	}

	justUpdateReport(formData) {
		return axios.post('report/just_update_report/', { formData: formData })
	}

	getAllReports() {
		return axios.get('report/view_reports/')
	}

	deleteAllReport() {
		return axios.get('report/delete_reports_all/')
	}

	getAllReportsNotMe() {
		return axios.get('report/view_reports_not/')
	}

	getAllReportsFinish() {
		return axios.get('report/view_reports_finish/')
	}

	sendSignXml(formData) {
		return axios.post('report/sign_xml/', {
			signedXml: formData.signedXml,
			reportId: formData.reportId,
		})
	}

	sendSignXmls(formData) {
		return axios.post('report/sign_xmls/', {
			signedXmls: formData.signedXmls,
			reportId: formData.reportId,
		})
	}

	approvedKmg(formData) {
		return axios.post('report/approve_kmg/', {
			reportId: formData.reportId,
		})
	}

	rejectReport(formData) {
		return axios.get('report/reject_report/', {
			params: {
				reportId: formData.reportId,
			},
		})
	}

	rejectReportMetall(formData) {
		return axios.get(`report/reject_after_edit/${formData.reportId}/`)
	}

	rejectReportDzo(formData) {
		return axios.post('report/reject_report/', {
			formData: formData,
		})
	}

	getAllDzo() {
		return axios.get('report/get_all_dzo/')
	}

	getBlackCatalog() {
		return axios.get('report/catalogs_is_black/')
	}

	getColorCatalog() {
		return axios.get('report/catalogs_is_color/')
	}

	downloadFile(file_url) {
		return axios.get('http://127.0.0.1:8000/media/report/Resume.pdf')
	}

	sendFile(formData) {
		return axios.post('report/send_file/', formData)
	}

	importExcel(formData) {
		return axios.post('report/import_excel/', formData)
	}

	downLoadExcel(formData) {
		return axios.get('report/download_excel/', {
			params: {
				reportId: formData.reportId,
				month: formData.month,
				year: formData.year,
				company: formData.company,
				dzo_id: formData.dzo_id
			},
			responseType: 'blob',
		})
	}

	rmReport(formData) {
		return axios.get('report/rm_report/', {
			params: {
				reportId: formData.reportId,
			},
		})
	}
}

export default new ReportService()
